import { Counter } from '@features/workspace/components/shared/counter';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from '@mui/material';
import { DocumentTableRow } from '@features/workspace/views/document/components/document-table-row';

export function DocumentsTable({
  title,
  documents,
  noDocumentsMessage,
  rejectedMode = false,
  hasBankingProduct,
}: any) {
  const hasNoData = documents.length === 0;
  const counterValue = documents.length;

  return (
    <>
      {title && (
        <Box alignItems="center" display="flex" flexDirection="row">
          <Box display="flex" ml={0}>
            <Typography variant="h6">{title}</Typography>
          </Box>
          {counterValue !== undefined && (
            <Box display="flex" ml={1}>
              <Counter value={counterValue} />
            </Box>
          )}
        </Box>
      )}
      <Box mb={3} my={2}>
        {hasNoData && (
          <Typography mt={title ? 0 : -2} variant="body1">
            <i>{noDocumentsMessage || 'No documents'}</i>
          </Typography>
        )}
        {!hasNoData && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="10%">Date</TableCell>
                <TableCell width="20%">Submitted By</TableCell>
                <TableCell width="30%">Document Type</TableCell>
                {!rejectedMode && (
                  <>
                    <TableCell align="center" width="20%">
                      Accept
                    </TableCell>
                    <TableCell align="center" width="20%">
                      Decline
                    </TableCell>
                    {/* <TableCell align="right"/> */}
                  </>
                )}
                {rejectedMode && (
                  <>
                    <TableCell width="20%">Date declined</TableCell>
                    <TableCell width="20%" />
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {!!documents.length &&
                documents.map((item: any) => (
                  <DocumentTableRow
                    key={`document-table-item-${item.id}`}
                    document={item}
                    isLastRow={item === documents[documents.length - 1]}
                    rejectedMode={rejectedMode}
                  />
                ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </>
  );
}
